import React from "react"
import { Grid, Stack, Text } from "@chakra-ui/react"
import Image from "@app/components/Image/Image"

export interface ProductKeyBenefitsProps {
  product: any
  benefits: NormalisedKeyBenefit[]
}

const ProductKeyBenefits = ({ product, benefits }: ProductKeyBenefitsProps) => {
  const applicableBenefits = benefits.reduce<NormalisedKeyBenefit[]>(
    (acc, benefit) => (product.tags.includes(benefit.tag) ? [...acc, benefit] : acc),
    []
  )

  return (
    <Grid templateColumns="repeat(3, 1fr)" columnGap={2} rowGap={2.5}>
      {applicableBenefits.map(benefit => (
        <Stack alignItems="center" key={benefit.tag} textAlign={`center`}>
          <Image {...benefit.image} height={12} objectFit={`contain`} objectPosition={`center`} />
          <Text size="sm">{benefit.title}</Text>
        </Stack>
      ))}
    </Grid>
  )
}

export default ProductKeyBenefits
